'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _FormattedNumber = require('I18n/components/FormattedNumber');

var _FormattedNumber2 = _interopRequireDefault(_FormattedNumber);

var _UIModal = require('UIComponents/dialog/UIModal');

var _UIModal2 = _interopRequireDefault(_UIModal);

var _UIDialogCloseButton = require('UIComponents/dialog/UIDialogCloseButton');

var _UIDialogCloseButton2 = _interopRequireDefault(_UIDialogCloseButton);

var _HR = require('UIComponents/elements/HR');

var _HR2 = _interopRequireDefault(_HR);

var _H = require('UIComponents/elements/headings/H6');

var _H2 = _interopRequireDefault(_H);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _ImmutableMerchandiseIdMap = require('self-service-api/constants/ImmutableMerchandiseIdMap');

var _ImmutableMerchandiseIdMap2 = _interopRequireDefault(_ImmutableMerchandiseIdMap);

var _merchUtils = require('self-service-api/core/utilities/merchUtils');

var _CurrencySelectors = require('pricing-pages-unified-ui/selectors/CurrencySelectors');

var _PriceBreakdownRow = require('pricing-pages-unified-ui/components/calculator/PriceBreakdownRow');

var _PriceBreakdownRow2 = _interopRequireDefault(_PriceBreakdownRow);

var _pricingUtils = require('pricing-pages-unified-ui/utils/pricingUtils');

var _PriceDisplay = require('pricing-pages-unified-ui/components/common/pricing/PriceDisplay');

var _PriceDisplay2 = _interopRequireDefault(_PriceDisplay);

var _FormattedJSXMessage = require('I18n/components/FormattedJSXMessage');

var _FormattedJSXMessage2 = _interopRequireDefault(_FormattedJSXMessage);

var _AuthAdminSelectors = require('pricing-pages-unified-ui/selectors/AuthAdminSelectors');

var _CurrentSubscriptionsSelectors = require('pricing-pages-unified-ui/selectors/CurrentSubscriptionsSelectors');

var _PricingSelectors = require('pricing-pages-unified-ui/selectors/PricingSelectors');

var _PromotionSelectors = require('pricing-pages-unified-ui/selectors/PromotionSelectors');

var _MerchandiseIdLists = require('self-service-api/constants/MerchandiseIdLists');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MODAL_WIDTH = 600;
var getSum = function getSum(a, b) {
  return a + b;
};

var ModalBody = _styledComponents2.default.div.withConfig({
  displayName: 'BundlePricingBreakdownModal__ModalBody'
})(['padding:0 25px 10px 25px;']);

var ModalTitle = _styledComponents2.default.div.withConfig({
  displayName: 'BundlePricingBreakdownModal__ModalTitle'
})(['font-weight:600;font-size:22px;text-align:center;padding-top:40px;padding-bottom:50px;']);

var _getLang = function _getLang(path) {
  return _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.calculator.' + path });
};

var BundlePricingBreakdownModal = function (_React$Component) {
  _inherits(BundlePricingBreakdownModal, _React$Component);

  function BundlePricingBreakdownModal() {
    _classCallCheck(this, BundlePricingBreakdownModal);

    return _possibleConstructorReturn(this, (BundlePricingBreakdownModal.__proto__ || Object.getPrototypeOf(BundlePricingBreakdownModal)).apply(this, arguments));
  }

  _createClass(BundlePricingBreakdownModal, [{
    key: 'getDefaultTermIdForMerch',
    value: function getDefaultTermIdForMerch(eligiblePromotions, merchId) {
      var eligibleTermIds = (0, _pricingUtils.getEligibleTermIds)({
        eligiblePromotions: eligiblePromotions,
        merchandiseId: merchId
      });
      var termId = eligibleTermIds.monthly;

      if (!termId) {
        termId = eligibleTermIds.annual;
      }

      return termId;
    }
  }, {
    key: 'getAdditionalUnitPricePerMonth',
    value: function getAdditionalUnitPricePerMonth(merchId, activeCurrencyCode) {
      var _props = this.props,
          getAdditionalContactsUnitPrice = _props.getAdditionalContactsUnitPrice,
          getAdditionalUsersUnitPrice = _props.getAdditionalUsersUnitPrice,
          eligiblePromotions = _props.eligiblePromotions;

      var isContactsBased = _MerchandiseIdLists.CONTACT_BASED_MERCHANDISE_IDS.includes(merchId);

      var langPath = isContactsBased ? 'additionalContacts_jsx' : 'additionalUsers_jsx';

      var termId = this.getDefaultTermIdForMerch(eligiblePromotions, merchId);
      var price = isContactsBased ? getAdditionalContactsUnitPrice(merchId, termId) : getAdditionalUsersUnitPrice(merchId, termId);

      return _react2.default.createElement(
        _Small2.default,
        { use: 'help' },
        _react2.default.createElement(_FormattedJSXMessage2.default, {
          message: 'pricingPage.calculator.priceBreakdown.perAdditionalUnitSubtext.' + langPath,
          options: {
            price: price,
            currencyCode: activeCurrencyCode
          },
          elements: { PriceDisplay: _PriceDisplay2.default, FormattedNumber: _FormattedNumber2.default }
        })
      );
    }
  }, {
    key: 'getAdjustedQuantity',
    value: function getAdjustedQuantity(merchId) {
      var _props2 = this.props,
          marketingPlanSelected = _props2.marketingPlanSelected,
          marketingUnits = _props2.marketingUnits,
          salesPlanSelected = _props2.salesPlanSelected,
          salesUnits = _props2.salesUnits,
          servicePlanSelected = _props2.servicePlanSelected,
          serviceUnits = _props2.serviceUnits;


      var merchObj = _ImmutableMerchandiseIdMap2.default[merchId];
      var edition = merchObj.edition,
          includedAdditionalUnits = merchObj.includedAdditionalUnits;


      if (merchId === marketingPlanSelected) {
        return (0, _merchUtils.getAdditionalUnitsQuantityMinusIncluded)(marketingUnits, merchId);
      }

      if (merchId === salesPlanSelected) {
        if (edition === 'starter') {
          return salesUnits + includedAdditionalUnits;
        }

        return salesUnits;
      }

      if (merchId === servicePlanSelected) {
        if (edition === 'starter') {
          return serviceUnits + includedAdditionalUnits;
        }

        return serviceUnits;
      }

      return 1;
    }
  }, {
    key: 'getPriceSubtext',
    value: function getPriceSubtext(eligiblePromotions) {
      var merchId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var activeTerm = 'monthly';

      var eligibleTermIds = (0, _pricingUtils.getEligibleTermIds)({
        eligiblePromotions: eligiblePromotions,
        merchandiseId: merchId
      });

      if (!eligibleTermIds.monthly) {
        activeTerm = 'annual';
      }

      return _react2.default.createElement(
        _Small2.default,
        { use: 'help' },
        _react2.default.createElement(_FormattedMessage2.default, {
          message: 'pricingPage.calculator.priceBreakdown.priceSubtextParentheses.' + activeTerm
        })
      );
    }
  }, {
    key: 'getBillingName',
    value: function getBillingName(merchId) {
      var quantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var merchObj = _ImmutableMerchandiseIdMap2.default[merchId];
      var billingNameKey = merchObj.billingNameKey;

      // Note: quantity may not always be used in the billingNameKey string,
      //       but there should always be a quantity we can pass

      return _react2.default.createElement(_FormattedMessage2.default, {
        message: 'pricing-pages.billingNames.' + billingNameKey,
        options: { count: quantity }
      });
    }
  }, {
    key: 'getCostToGetStarted',
    value: function getCostToGetStarted() {
      var _props3 = this.props,
          oneTimeFees = _props3.oneTimeFees,
          recurringFees = _props3.recurringFees,
          eligiblePromotions = _props3.eligiblePromotions;

      var oneTimeCost = oneTimeFees.map(function (fee) {
        return fee.calculatedPrice;
      }).reduce(getSum, 0);

      var firstTimeRecurringCost = recurringFees.map(function (fee) {
        var eligibleTermIds = (0, _pricingUtils.getEligibleTermIds)({
          eligiblePromotions: eligiblePromotions,
          merchandiseId: fee.merchId
        });

        if (!eligibleTermIds.monthly) {
          return fee.annually.calculatedPrice;
        }

        return fee.monthly.calculatedPrice;
      }).reduce(getSum, 0);

      return oneTimeCost + firstTimeRecurringCost;
    }
  }, {
    key: 'renderMonthlyFees',
    value: function renderMonthlyFees() {
      var _this2 = this;

      var _props4 = this.props,
          monthlyFees = _props4.monthlyFees,
          activeCurrencyCode = _props4.activeCurrencyCode,
          eligiblePromotions = _props4.eligiblePromotions;


      return monthlyFees.map(function (recurringMerch) {
        var productMerch = recurringMerch.priceBreakdown[0];
        var additionalUnitMerch = recurringMerch.priceBreakdown.length > 1 ? recurringMerch.priceBreakdown[1] : null;
        var adjustedQuantity = _this2.getAdjustedQuantity(productMerch.merchandiseId);

        return recurringMerch.calculatedPrice !== 0 ? _react2.default.createElement(
          _react2.default.Fragment,
          { key: productMerch.merchandiseId },
          _react2.default.createElement(_PriceBreakdownRow2.default, {
            price: productMerch.calculatedPrice,
            currencyCode: activeCurrencyCode,
            priceDisclaimer: _this2.getPriceSubtext(eligiblePromotions, productMerch.merchandiseId),
            text: _this2.getBillingName(productMerch.merchandiseId, adjustedQuantity),
            isMonthly: true
          }),
          additionalUnitMerch && !!adjustedQuantity && _react2.default.createElement(_PriceBreakdownRow2.default, {
            price: additionalUnitMerch.calculatedPrice,
            currencyCode: activeCurrencyCode,
            priceDisclaimer: _this2.getPriceSubtext(eligiblePromotions, productMerch.merchandiseId),
            text: _this2.getBillingName(additionalUnitMerch.merchandiseId, adjustedQuantity),
            isMonthly: true,
            costPerUnitSubtext: _this2.getAdditionalUnitPricePerMonth(productMerch.merchandiseId, activeCurrencyCode)
          })
        ) : null;
      });
    }
  }, {
    key: 'renderOneTimeFee',
    value: function renderOneTimeFee(oneTimeFee) {
      var oneTimeFeePrice = oneTimeFee.calculatedPrice;
      var merchId = oneTimeFee.priceBreakdown[0].merchandiseId;
      var activeCurrencyCode = this.props.activeCurrencyCode;

      return _react2.default.createElement(_PriceBreakdownRow2.default, {
        key: merchId,
        price: oneTimeFeePrice,
        currencyCode: activeCurrencyCode,
        priceDisclaimer: _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.notes.oneTimeFeeParentheses' }),
        text: this.getBillingName(merchId)
      });
    }
  }, {
    key: 'renderOneTimeFees',
    value: function renderOneTimeFees() {
      var _this3 = this;

      var oneTimeFees = this.props.oneTimeFees;


      return _react2.default.createElement(
        'div',
        { className: 'm-top-9' },
        _react2.default.createElement(
          _H2.default,
          { className: 'text-left m-left-7 m-bottom-7' },
          _getLang('priceBreakdown.oneTimeFees')
        ),
        oneTimeFees.filter(function (fee) {
          return fee.priceBreakdown.length;
        }).map(function (fee) {
          return _this3.renderOneTimeFee(fee);
        })
      );
    }
  }, {
    key: 'renderTotalCosts',
    value: function renderTotalCosts() {
      var _props5 = this.props,
          activeCurrencyCode = _props5.activeCurrencyCode,
          totalPrice = _props5.totalPrice;

      return _react2.default.createElement(
        'div',
        { style: { width: '100%' } },
        _react2.default.createElement(_PriceBreakdownRow2.default, {
          text: _getLang('priceBreakdown.monthlyCost'),
          price: totalPrice.monthly.calculatedPrice,
          currencyCode: activeCurrencyCode,
          isMonthly: true,
          isTotal: true
        }),
        _react2.default.createElement(_PriceBreakdownRow2.default, {
          text: _getLang('priceBreakdown.oneTimeFees'),
          price: totalPrice.oneTimeFee.calculatedPrice,
          currencyCode: activeCurrencyCode,
          isTotal: true
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props6 = this.props,
          onCloseClick = _props6.onCloseClick,
          oneTimeFees = _props6.oneTimeFees;


      return _react2.default.createElement(
        _UIModal2.default,
        {
          use: 'conversational',
          width: MODAL_WIDTH,
          onOverlayClick: onCloseClick
        },
        _react2.default.createElement(_UIDialogCloseButton2.default, { onClick: onCloseClick }),
        _react2.default.createElement(
          ModalTitle,
          null,
          _getLang('priceBreakdown.modal')
        ),
        _react2.default.createElement(
          ModalBody,
          null,
          _react2.default.createElement(
            _H2.default,
            { className: 'text-left m-left-7 m-bottom-0' },
            _getLang('priceBreakdown.recurringFees')
          ),
          this.renderMonthlyFees(),
          oneTimeFees && this.renderOneTimeFees(),
          _react2.default.createElement(_HR2.default, null),
          this.renderTotalCosts(),
          _react2.default.createElement(
            'div',
            { className: 'p-all-7 text-center' },
            _react2.default.createElement(
              _Small2.default,
              { use: 'help' },
              _getLang('priceBreakdown.footerModal')
            )
          )
        )
      );
    }
  }]);

  return BundlePricingBreakdownModal;
}(_react2.default.Component);

BundlePricingBreakdownModal.propTypes = {
  activeCurrencyCode: _react.PropTypes.string.isRequired,
  marketingPlanSelected: _react.PropTypes.number,
  marketingUnits: _react.PropTypes.number,
  getAdditionalContactsUnitPrice: _react.PropTypes.func.isRequired,
  getAdditionalUsersUnitPrice: _react.PropTypes.func.isRequired,
  salesPlanSelected: _react.PropTypes.number,
  salesUnits: _react.PropTypes.number,
  servicePlanSelected: _react.PropTypes.number,
  serviceUnits: _react.PropTypes.number,
  onCloseClick: _react.PropTypes.func.isRequired,
  eligiblePromotions: _react.PropTypes.object.isRequired,
  recurringFees: _react.PropTypes.array.isRequired,
  monthlyFees: _react.PropTypes.array.isRequired,
  oneTimeFees: _react.PropTypes.array.isRequired,
  totalPrice: _react.PropTypes.object.isRequired
};

var mapStateToProps = function mapStateToProps(state, props) {
  var marketingPlanSelected = props.marketingPlanSelected,
      marketingUnits = props.marketingUnits,
      pricingDependencies = props.pricingDependencies,
      salesPlanSelected = props.salesPlanSelected,
      salesUnits = props.salesUnits,
      selectedAddOns = props.selectedAddOns,
      selectedServices = props.selectedServices,
      servicePlanSelected = props.servicePlanSelected,
      serviceUnits = props.serviceUnits;


  var allPriceBreakdowns = (0, _pricingUtils.getMultiplePriceBreakdowns)({
    marketingPlanSelected: marketingPlanSelected,
    marketingUnits: marketingUnits,
    pricingDependencies: pricingDependencies,
    salesPlanSelected: salesPlanSelected,
    salesUnits: salesUnits,
    selectedAddOns: selectedAddOns,
    selectedServices: selectedServices,
    servicePlanSelected: servicePlanSelected,
    serviceUnits: serviceUnits
  });

  var getAdditionalContactsUnitPrice = function getAdditionalContactsUnitPrice(merchId, termId) {
    return (0, _PricingSelectors.additionalContactsMonthlyCostSelector)(state, merchId, termId);
  };
  var getAdditionalUsersUnitPrice = function getAdditionalUsersUnitPrice(merchId, termId) {
    return (0, _PricingSelectors.additionalSeatMonthlyCostSelector)(state, merchId, termId);
  };

  return {
    activeCurrencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state),
    authState: (0, _AuthAdminSelectors.authStateSelector)(state),
    currentSubscriptions: (0, _CurrentSubscriptionsSelectors.currentSubscriptionsSelector)(state),
    eligiblePromotions: (0, _PromotionSelectors.allPromotionsSelector)(state),
    getAdditionalContactsUnitPrice: getAdditionalContactsUnitPrice,
    getAdditionalUsersUnitPrice: getAdditionalUsersUnitPrice,
    recurringFees: allPriceBreakdowns.filter(function (breakdown) {
      return breakdown.monthly.calculatedPrice !== 0;
    }).map(function (breakdown) {
      return {
        merchId: breakdown.monthly.priceBreakdown[0].merchandiseId,
        monthly: breakdown.monthly,
        annually: breakdown.annually
      };
    }),
    monthlyFees: allPriceBreakdowns.filter(function (breakdown) {
      return breakdown.monthly.calculatedPrice !== 0;
    }).map(function (breakdown) {
      return breakdown.monthly;
    }),
    oneTimeFees: allPriceBreakdowns.filter(function (breakdown) {
      return breakdown.oneTimeFee.calculatedPrice !== 0;
    }).map(function (breakdown) {
      return breakdown.oneTimeFee;
    })
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(BundlePricingBreakdownModal);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/bundle-page/BundlePricingBreakdownModal.js
// module id = 709
// module chunks = 3 4